import React from 'react';
import { TextLink } from '../../../../design-system';
import { ShowAllButton as StyledShowAllButton } from './ModelFamilySelector.style';

interface ShowAllButtonProps {
  showAll: boolean;
  label: string;
  fewerLabel: string;
  onClick: () => void;
}

const ShowAllButton: React.FC<ShowAllButtonProps> = ({ showAll, label, fewerLabel, onClick }) => {
  const isAlpha = !process.env.IS_LEGACY;

  if (isAlpha) {
    return (
      <TextLink
        variant="standalone"
        size="md"
        type="button"
        onClick={onClick}
        data-testid="model-family-show-all"
      >
        {showAll ? fewerLabel : label}
      </TextLink>
    );
  }

  return (
    <StyledShowAllButton data-testid="model-family-show-all" onClick={onClick}>
      {showAll ? fewerLabel : label}
    </StyledShowAllButton>
  );
};

export default ShowAllButton;
